import React from 'react';
import classNames from 'classnames';
import styles from './AuthError.module.css';
import infoIcon from './info-icon.svg';

function AuthError() {
  const reload = () => {
    window.location = window.location.origin;
  };

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <img src={infoIcon} alt="Authentication failed" />
      </div>
      <div className={styles.body}>
        To access <strong>IBMS</strong>, your browser needs to accept third-party cookies.
        <br />
        Please change your browser settings to allow them and try to log in again.
      </div>
      <div className={styles.footer}>
        <button className={classNames('Global_RoundedButton', styles.button)} onClick={reload}>
          Log in to IBMS
        </button>
      </div>
    </div>
  );
}

export default AuthError;
